import type { FloorSystem } from '../../shared/schemas';

interface Props {
  systems: FloorSystem[];
  selected: string;
  onSelect(id: string): void;
}

export function SystemTabs({ systems, selected, onSelect }: Props) {
  const onKeyDown = (e: KeyboardEvent) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    const i = systems.findIndex((s) => s.id === selected);
    const next = systems[(i + (e.key === 'ArrowRight' ? 1 : systems.length - 1)) % systems.length];
    onSelect(next.id);
    document.getElementById(`fv-tab-${next.id}`)?.focus();
  };
  return (
    <div role="tablist" aria-label="Coating system" class="flex gap-1 rounded-xl bg-paper p-1" onKeyDown={onKeyDown}>
      {systems.map((s) => {
        const active = s.id === selected;
        return (
          <button
            key={s.id}
            id={`fv-tab-${s.id}`}
            role="tab"
            type="button"
            aria-selected={active}
            aria-controls="fv-colors"
            tabIndex={active ? 0 : -1}
            onClick={() => onSelect(s.id)}
            class={`min-h-11 flex-1 rounded-lg px-3 text-sm font-semibold transition-colors ${
              active ? 'bg-white text-ink shadow-sm' : 'text-muted hover:text-ink'
            }`}
          >
            {s.name}
          </button>
        );
      })}
    </div>
  );
}
